import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import { assetPrefix } from 'constants/app';

export const Container = styled.section`
  padding: 30px;
  margin: 50px auto;
  height: 100%;
  
  @media ${device.tablet} {
    padding: 0;
    max-width: 1300px;
    width: calc(100% - 150px);
    margin: 150px auto;
  }
}`;

export const AboutContainer = styled.section`
  margin: 100px 0;

  img {
    max-width: 100%;
  }
`;

export const AboutContainerInner = styled(Flex)`
  flex-direction: column;

  @media ${device.laptop} {
    flex-direction: row;
  }
`;

export const Paragraph = styled(Text).attrs({
  as: 'p',
  size: '18px',
  mt: '24px;',
  align: 'justify',
})`
  line-height: 1.5;
`;

export const ContactContainer = styled.div`
  display: block;

  @media ${device.laptop} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 25px;
    grid-row-gap: 0px;
  }
`;

export const ContactBox = styled.div`
  border: 1px solid ${color.gainsboro};
  border-radius: 10px;
  margin-bottom: 25px;

  .address {
    margin: 22px;
    background: url(${assetPrefix}/images/pin.png) no-repeat top left;
    padding-left: 68px;
  }

  h5 {
    font-size: 16px;

    @media ${device.tablet} {
      font-size: 24px;
      margin-bottom: 10px;
    }
  }

  p {
    font-size: 14px;

    @media ${device.tablet} {
      font-size: 18px;
      margin-bottom: 20px;
    }
  }
`;

export const Title = styled(Text).attrs({
  as: 'h3',
  family: 'bold',
})<{ mb: number }>`
  font-size: 40px;
  margin-bottom: ${(props) => (props.mb ? props.mb : '20px')};

  @media ${device.tablet} {
    font-size: 26px;
  }

  @media ${device.laptop} {
    font-size: 40px;
  }
`;

export const MiniTitle = styled(Text).attrs({
  as: 'h3',
  family: 'bold',
})`
  font-size: 30px;
  margin-bottom: 20px;

  @media ${device.tablet} {
    font-size: 20px;
  }

  @media ${device.laptop} {
    font-size: 30px;
  }
`;
